import { useTranslation } from "react-i18next";
import { Accordion, AccordionDetails, AccordionSummary, Grid, Stack, Typography } from "@mui/material";
import React from "react";
import { ExpandMore } from "@mui/icons-material";
import DisableFormTextField from "../../_components/DisableFormTextField";

const FirstDriver = () => {
    const { t } = useTranslation('booking');

    return (
        <Accordion>
            <AccordionSummary expandIcon={<ExpandMore />}>
                <Stack direction="row" alignItems="center" justifyContent="space-between" width="100%">
                    <Typography variant="h5">
                        {t('label.mainDriver')}
                    </Typography>
                </Stack>
            </AccordionSummary>
            <AccordionDetails>
                <Grid container rowSpacing={1} columnSpacing={3}>
                    <Grid item xs={12} sm={3}>
                        <DisableFormTextField name="firstDriver.id" label={'label.id'}/>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <DisableFormTextField name="firstDriver.firstName" label={'label.firstName'}/>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <DisableFormTextField name="firstDriver.lastName" label={'label.lastName'}/>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <DisableFormTextField name="firstDriver.birthDate" label={'label.birthDate'}/>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <DisableFormTextField name="firstDriver.birthNation" label={'label.nationOfBirth'}/>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <DisableFormTextField name="firstDriver.birthPlace" label={'label.placeOfBirth'}/>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <DisableFormTextField name="firstDriver.residenceCountry" label={'label.countryOfResidence'}/>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <DisableFormTextField name="firstDriver.fiscalCode" label={'label.fiscalCode'}/>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <DisableFormTextField name="firstDriver.gender" label={'label.gender'}/>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <DisableFormTextField name="firstDriver.drivingLicenseNumber" label={'label.drivingLicenseNumber'}/>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <DisableFormTextField name="firstDriver.email" label={'label.email'}/>
                    </Grid>
                    <Grid item xs={12} sm={1}>
                        <DisableFormTextField name="firstDriver.mobilePrefix" label={'label.prefix'}/>
                    </Grid>
                    <Grid item xs={12} sm={2}>
                        <DisableFormTextField name="firstDriver.mobile" label={'label.mobile'}/>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <DisableFormTextField name="firstDriver.webCheckIn" label={'label.webCheckIn'}/>
                    </Grid>
                </Grid>
            </AccordionDetails>
        </Accordion >
    )
}

export default FirstDriver;
